import { Component, OnInit } from '@angular/core';
import * as highcharts from "highcharts";

@Component({
  selector: 'app-arearange-chart',
  templateUrl: './arearange-chart.component.html',
  styleUrls: ['./arearange-chart.component.scss']
})
export class ArearangeChartComponent implements OnInit {
  chartOptions = {}
  highcharts = highcharts
  constructor() { }

  ngOnInit(): void {
    this.plotChart();
  }
  plotChart(){
    this.chartOptions = {
      chart: {
        type: "area",
        backgroundColor:"transparent"
      },
      accessibility: {
        description: "",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        allowDecimals: false,
        labels: {
          // formatter: function () {
          //   return this.value; // clean, unformatted number for year
          // },
        },
        // accessibility: {
        //   rangeDescription: "Range: 1940 to 2018.",
        // },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          // formatter: function () {
          //   return this.value / 1000 + "k";
          // },
        },
      },
      tooltip: {
        pointFormat:
          "{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}",
      },
      plotOptions: {
        area: {
          stacking: 'normal',
          marker: {
            enabled: false,
            symbol: "circle",
            radius: 2,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
        },
      },
      series: [
     
        {
          color:"#F28556",
          fillColor: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            color:'#FFAD8A',
            stops: [
              [0, '#FFD8C8'],
              [100,'#F28556']
            ]
            
          },
          data:   [["Jan",16],
          ["Feb",11],
          ["Mar",40],
          ["Apr",50],
          ["May",65],]
        },
      ],
    };
  }

}
